/* ============================================================
   sm-vs-hurd.js - the door signs on the one page kit (adapter 'hurd'; sections/sm-vel.liquid,
   assets/sm-vel-sida.js). Lane L1, samraeming 2026-09-30.

   The engine is assets/sm-hurd-vel.js: the drawing, the size rule, the variant pick and the production
   spec of sm-hurda-config.js 0cbf722d, moved there verbatim. This file is the glue the old page had
   (steps, material switch across the four products, URL, cart properties, the guard against an empty
   name) plus the kit hooks: material, shape, size and frame tiles drawn from the photo atlas with the
   customer's names at tile scale, letter tiles on the chosen material, the frame step (LINA 2,2 x 2,5 mm
   on acrylic as today, the engraved band on aluminium, steel and brass: owner 2026-09-30, aluminium
   "hafa eins" as steel and brass, +1.000 kr, lane E1).

   Steps (template blocks): nofn (sersnid: names, address), letur (val, list of 4 fonts), efni (sersnid,
   7 tiles), logun (sersnid), staerd (sersnid), rammi (kit block), magn, aths, traust.
   All customer text comes from snippets/sm-vl-hurd.liquid (ctx.vel.ord). ES5, ASCII.

   E7 (owner spec 2026-09-30, samraeming/E7-hurd-sida/SPEC.md): steel in two forms ("Stal, svartir stafir" =
   steel, "Stal, grafid" = steelg, a material added to each engine instance at start, the engine file untouched),
   one line under Efni for the chosen material, the treatment check boxes (Syruthvottur on steelg, Varnarefni on
   brass, never preset), size as small buttons with price, frame as small buttons. Every option
   that needs a product variant (steelg, the treatments, the metal frame) stays hidden until the variant exists.
   Owner addendum 2026-09-30 (seinna svar): the material line and its treatment check box sit directly under the
   ROW the chosen material is drawn in (the acrylic row or the metal row), never after both rows.
   ============================================================ */
(function () {
  'use strict';
  /* the page's font ids (letur step values) -> the old page's font keys (FONTS in the engine) */
  var LETUR = { 'cormorantgaramond-600': 'cormorant', 'montserrat-500': 'montserrat', 'dancingscript-600': 'greatvibes', 'jost-500': 'fraunces' };
  var LETUR_ID = {};
  Object.keys(LETUR).forEach(function (k) { LETUR_ID[LETUR[k]] = k; });
  var EFNI = ['gold', 'silver', 'black', 'white', 'aluminum', 'steel', 'steelg', 'brass'];
  /* lysandi slod (review 2026-10-01): Icelandic material slugs for the URL - acrylic is never written,
     "litur" (the real Shopify option) already names it; only a metal/cross-product material needs its
     own key, and only in Icelandic. LITUR_EFNI reverses the 4 acrylic Shopify colour names so a plain
     "litur=" link still restores the material on its own, without an "efni" at all. */
  var EFNI_LYKILL = { aluminum: 'al', steel: 'stal-svartir', steelg: 'stal-grafid', brass: 'messing' };
  var EFNI_LYKILL_INV = {};
  Object.keys(EFNI_LYKILL).forEach(function (k) { EFNI_LYKILL_INV[EFNI_LYKILL[k]] = k; });
  var LITUR_EFNI = { gull: 'gold', hvitt: 'white', silfur: 'silver', svart: 'black' };
  /* the engraved metal frame (+1.000 kr, band RAMMI-LARETT / RAMMI-LODRETT-90): aluminium like steel and brass */
  var MALMUR = { aluminum: 1, steel: 1, steelg: 1, brass: 1 };
  /* Skraut (eigandi 08.10): step "skraut" (val, list Ekkert / Thrir tiglar, free, no variant). The value of the radio is the list text. */
  var SK_TIGLAR = '\u00der\u00edr t\u00edglar';
  /* Emoji and other pictographs cannot be engraved (the kit's rule for text steps) */
  /* CW 19.10 (owner): the paw U+1F43E is allowed and engraved as a vector (SMFram.loppa); it counts as one character */
  var TJAKN = /(?!\uD83D\uDC3E)[\uD83C-\uDBFF][\uDC00-\uDFFF]|\uFE0F|\u200D/;
  function stafir(t) { return String(t == null ? '' : t).replace(/\uD83D\uDC3E/g, 'x').length; }

  function E() { return window.SMHurd; }
  function trim(t) { return String(t == null ? '' : t).replace(/^\s+|\s+$/g, ''); }
  function fylla(t, b) { return String(t || '').replace(/\{(\w+)\}/g, function (m, k) { return b && b[k] != null ? b[k] : m; }); }
  function kr(aurar) { return String(Math.round((aurar || 0) / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.'; }
  function ord(ctx, k, b) { var o = (ctx.vel && ctx.vel.ord) || {}; return fylla(o[k] || '', b); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function r4(n) { return Math.round(n * 10000) / 10000; }

  /* the kit's product data -> the engine's (variants with option names, option names) */
  function vorugogn(v) {
    return {
      variants: (v.afbrigdi || []).map(function (a) { return { id: a.id, price: a.verd, options: (a.n || []).slice(), available: a.til }; }),
      options: (v.valkostir || []).map(function (o) { return o.nafn; })
    };
  }
  function nyCfg(hd) {
    return { material: hd.upphaf.efni, size: 'M', sizeManual: false, shape: hd.upphaf.form, border: true, font: 'montserrat', names: '', address: '', includeAddress: false, notes: '', notesOpen: false, qty: 1 };
  }
  function afrita(a, b) { Object.keys(b).forEach(function (k) { a[k] = b[k]; }); return a; }

  /* owner 07.10.2026: "Vélin stækkar bara sjálfgefið en fólk getur svo minnkað það ef það vill hafa það lítið."
     (Later the same day: the first typed character sets Litid, see the names box handler; this function then grows it.)
     The size starts at Mid and only GROWS by itself, when the names pass what the size holds well (SIZES[].rec:
     Lítið 2, Mið 5 (14.10, var 4), Stórt 6; past 6 it stays Stórt, the engine shrinks the letters). Never smaller by itself, also
     when names are removed. A size the customer picked (sizeManual) is never changed, whatever the count (a
     small sign with 5 names is allowed, the engine fits the letters). Replaces the engine's autoSize (n<=2 gave
     Lítið from Mid: an acrylic sign with two names went to the cart as Lítið 5.990 kr); v.autoSize is not called. */
  var STAERDIR = ['S', 'M', 'L'];
  function nafnafjoldi(c) { return String(c.names || '').split('\n').filter(function (l) { return trim(l); }).length; }
  function staekka(v, c) {
    if (c.sizeManual || v.MAT[c.material].fixedSize) return;
    var i = STAERDIR.indexOf(c.size), n = nafnafjoldi(c);
    if (i < 0) return;
    while (i < STAERDIR.length - 1 && n > v.SIZES[STAERDIR[i]].rec) i++;
    c.size = STAERDIR[i];
  }
  /* the material rules of the old page's material click (sm-hurda-config.js [data-mat] handler and
     applyProduct): no oval on aluminium, steel and brass; aluminium has one size; leaving it gives back the
     size from before aluminium (Mid if none), then it may grow */
  function setjaEfni(v, cfg, k) {
    var M = v.MAT[k];
    cfg.material = k;
    if (M.noOval && cfg.shape === 'oval') cfg.shape = 'rect';
    if (M.fixedSize) { if (cfg.size !== M.fixedSize) cfg.sizeFyrir = cfg.size; cfg.size = M.fixedSize; }
    else if (cfg.size === 'AL') { cfg.size = STAERDIR.indexOf(cfg.sizeFyrir) >= 0 ? cfg.sizeFyrir : 'M'; staekka(v, cfg); }
  }

  /* ---------- one state per page (ctx.hd) ---------- */
  function byrja(ctx) {
    var vel = ctx.vel || {}, hd = {
      upphaf: vel.upphaf || { efni: 'silver', form: 'rect' }, atlas: vel.atlas || {}, sw: vel.sw || {},
      snert: false, sjalf: 'med', malmSjalf: 'an', medferd: { steelg: false, brass: false }
    };
    /* engraved steel is the same brushed steel plate: same photo atlas and swatch as steel */
    if (hd.atlas['rect-steel'] && !hd.atlas['rect-steelg']) hd.atlas['rect-steelg'] = hd.atlas['rect-steel'];
    if (hd.sw.steel && !hd.sw.steelg) hd.sw.steelg = hd.sw.steel;
    /* 02.10 (owner): engraved letters on black aluminium show bare brushed metal, the same steel image the
       Owala bottle preview uses for its engraving (assets/sm-brusi-stal.webp); CSS (sm-vs-hurd.css) clips it to
       the letters. The URL comes from a sibling asset of the page's own swatch (same theme folder). */
    try {
      var swAl = String(hd.sw.aluminum || hd.sw.steel || '');
      if (swAl) document.documentElement.style.setProperty('--sm-al-stal', 'url("' + swAl.replace(/[^\/]*$/, '') + 'sm-brusi-stal-vl.webp")');
    } catch (eAl) {}
    hd.cfg = nyCfg(hd);
    var v0 = vorugogn(ctx.vara());
    /* the preview instance */
    var rot = document.createElement('div');
    rot.className = 'vs-hurd-svid';
    rot.innerHTML = '<div class="vs-hurd-plata"><div data-hurd-sella><img class="vs-hurd-atlas" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt="" draggable="false" decoding="async"><div class="vs-hurd-texti"></div></div></div>';
    hd.rot = rot;
    hd.plata = rot.firstChild;
    var sella = hd.plata.firstChild;
    atlasAttr(rot, hd, window.innerWidth > 1000 ? 2400 : 1080);
    hd.vel = E().vel({ root: rot, plate: sella, plateImg: sella.firstChild, plateText: sella.lastChild,
      D: { variants: v0.variants, options: v0.options, handle: ctx.vara().handle }, cfg: hd.cfg });
    hd.vel.D.family = (hd.vel.FAM_OF[ctx.vara().handle] || {}).fam;
    grafid(ctx, hd.vel);
    /* the tile instance: detached nodes, never measured for a file */
    /* E5: in an inert document (no browsing context), so the instance's picture is never fetched */
    var trot = (document.implementation && document.implementation.createHTMLDocument ? document.implementation.createHTMLDocument('') : document).createElement('div');
    trot.innerHTML = '<div data-hurd-sella><img class="vs-hurd-atlas" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt=""><div class="vs-hurd-texti"></div></div>';
    atlasAttr(trot, hd, 1080);
    var ts = trot.firstChild;
    hd.tcfg = afrita({}, hd.cfg);
    hd.tvel = E().vel({ root: trot, plate: ts, plateImg: ts.firstChild, plateText: ts.lastChild, D: {}, cfg: hd.tcfg });
    hd.tsella = ts;
    grafid(ctx, hd.tvel);
    /* the measuring instance for the production file: a 480 px photo cell off screen, the size of the old
       page's desktop preview, so every file is measured the same way on phones and computers */
    var mrot = document.createElement('div');
    mrot.className = 'vs-hurd-maeling';
    mrot.setAttribute('aria-hidden', 'true');
    mrot.innerHTML = '<div class="vs-hurd-plata"><div data-hurd-sella style="width:480px;height:480px;left:0;top:0"><img class="vs-hurd-atlas" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" alt=""><div class="vs-hurd-texti"></div></div></div>';
    atlasAttr(mrot, hd, 1080);
    var ms = mrot.firstChild.firstChild;
    hd.mrot = mrot;
    hd.mvel = E().vel({ root: mrot, plate: ms, plateImg: ms.firstChild, plateText: ms.lastChild, D: {}, cfg: hd.cfg });
    grafid(ctx, hd.mvel);
    /* prices of every product of the family (the material tiles show the lowest price of each material) */
    var F = ctx.fjolskylda;
    if (F && F.vorur) Object.keys(F.vorur).forEach(function (h) { var g = vorugogn(F.vorur[h]); hd.vel.verd(h, g.variants, g.options, F.vorur[h].titill); });
    hd.vel.verd(ctx.vara().handle, v0.variants, v0.options, ctx.vara().titill);
    ctx.hd = hd;
    return hd;
  }
  function atlasAttr(el, hd, w) {
    Object.keys(hd.atlas).forEach(function (k) {
      var u = String(hd.atlas[k] || '');
      if (!u) return;
      /* acrylic: the Files photos in the width the old page chose (sm-plate-frame.js), webp */
      if (/\/files\//.test(u)) u += (u.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w + '&format=webp';
      el.setAttribute('data-atlas-' + k, u);
    });
  }
  /* the product the engine works on = the product the kit shows */
  function samstillaVoru(ctx) {
    var hd = ctx.hd, v = ctx.vara();
    if (hd.handle === v.handle) return;
    hd.handle = v.handle;
    var g = vorugogn(v);
    hd.vel.vorur(v.handle, g.variants, g.options);
  }
  /* the frame the customer gets: the kit's rule (their choice, or while untouched the default of the
     material class), known before the kit settles its step, so the variant is picked with it */
  function rammiNu(ctx, s, efni) {
    var hd = ctx.hd;
    /* a choice made without a click (the kit API, a restored state): the step differs from the default of
       the material it was settled for */
    if (!hd.snert && !efni && s.rammi && hd.sidastaEfni === hd.cfg.material && s.rammi !== (MALMUR[hd.cfg.material] ? hd.malmSjalf : hd.sjalf)) hd.snert = true;
    /* metal whose product has no Rammi option: the frame step is hidden and the sign has no frame */
    if (vantarRammaEfni(ctx, efni || hd.cfg.material)) return 'an';
    if (hd.snert) return s.rammi === 'an' ? 'an' : 'med';
    return MALMUR[efni || hd.cfg.material] ? hd.malmSjalf : hd.sjalf;
  }
  function lesaStodu(ctx, s) {
    var c = ctx.hd.cfg;
    if (s.letur && LETUR[s.letur]) c.font = LETUR[s.letur];
    c.border = rammiNu(ctx, s) === 'med';
    c.skraut = s.skraut === SK_TIGLAR;
    c.notes = s.aths || '';
  }
  /* the Shopify option that carries the frame (the proposed "Rammi" of the steel and brass product and of
     the aluminium product; today's aluminium "Utlit" is price neutral and does not count) */
  function rammaValkostur(v) {
    for (var i = 0; i < v.valkostir.length; i++) if (String(v.valkostir[i].nafn).toLowerCase().indexOf('rammi') >= 0) return i;
    /* aluminium's "Útlit" (Án ramma / Með ramma) carries the frame too (owner 01.10: frame on aluminium) */
    for (var k = 0; k < v.valkostir.length; k++) {
      var gildi = (v.valkostir[k].gildi || []).map(function (x) { return x && x.nafn != null ? x.nafn : x; }).join(' ').toLowerCase();
      if (gildi.indexOf('með ramma') >= 0) return k;
    }
    return -1;
  }
  function erMed(nafn) { return String(nafn || '').toLowerCase().indexOf('með') >= 0; }
  /* the engine's variant for the product h, then (only where the product has a "Rammi" option) the
     variant with the same other options and the chosen frame */
  function afbrigdiI(ctx, h) {
    var hd = ctx.hd, F = ctx.fjolskylda, v = h === ctx.vara().handle ? ctx.vara() : F && F.vorur && F.vorur[h];
    if (!v) return null;
    var g = vorugogn(v);
    hd.vel.vorur(h, g.variants, g.options);
    var a = hd.vel.currentVariant();
    hd.handle = null;
    if (!a) return null;
    var ri = rammaValkostur(v);
    if (ri >= 0) {
      var med = hd.cfg.border, besta = null;
      g.variants.forEach(function (x) {
        if (besta || erMed(x.options[ri]) !== med) return;
        for (var j = 0; j < x.options.length; j++) if (j !== ri && x.options[j] !== a.options[j]) return;
        besta = x;
      });
      /* sparse (SPEC 2.4): no such variant; the kit stops the add on metal (rammi-verd) */
      if (besta) a = besta;
    }
    /* E7: steel, engraved steel and brass by their exact Litur value (with the treatment when chosen), the other
       options as picked; without the proposed values this finds today's variant again */
    var ci = liturIdx(v), e = ctx.hd.cfg.material;
    if (ci >= 0 && (e === 'steel' || e === 'steelg' || e === 'brass')) {
      var lv = liturFyrir(v, e, medferdTil(ctx, e) && !!ctx.hd.medferd[e]), lb = null;
      if (lv && a.options[ci] !== lv) {
        g.variants.forEach(function (x) {
          if (lb || x.options[ci] !== lv) return;
          for (var j = 0; j < x.options.length; j++) if (j !== ci && x.options[j] !== a.options[j]) return;
          lb = x;
        });
        if (lb) a = lb;
      }
    }
    return a;
  }

  /* ---------- E7: engraved steel, the treatments (the Litur value of the steel and brass product) ---------- */
  /* engraved steel as a material of an engine instance: the steel of the engine (size rule, geometry, frame) with
     the letters engraved into the steel (tone in tone: the SMBarm ink #2b2f33 at 0.76, shade above, light lip below,
     22.10 owner: "ekki eins og grafið, meira eins og svart") and its own name and file material */
  function grafid(ctx, v) {
    if (!v.MAT.steelg) v.MAT.steelg = { name: ord(ctx, 'nafn_steelg') || 'Stál, grafið', short: ord(ctx, 'merki_steelg') || 'Stál, grafið', swatch: 'steel', text: 'rgb(108,111,114)', skuggi: '0 -0.05em 0.03em rgba(0,0,0,0.5), 0 0.05em 0 rgba(255,255,255,0.6)', sia: 'drop-shadow(0 -0.5px 0.3px rgba(0,0,0,0.5)) drop-shadow(0 0.5px 0 rgba(255,255,255,0.6))', pat: ['grafi'], fam: 'metal', noOval: true };
    /* brass is always engraved (owner rule): the config engine's "Messing" name/short is overridden here at
       runtime from the dictionary (merki_brass/nafn_brass), the engine file stays untouched. text is a dark
       brass tone, never black (black letters exist on steel only, efni-og-litir.md) */
    if (v.MAT.brass) {
      v.MAT.brass.name = ord(ctx, 'nafn_brass') || 'Messing, grafið';
      v.MAT.brass.short = ord(ctx, 'merki_brass') || 'Messing, grafið';
      /* 22.10 (eigandi): grafið = tónn í tón, sama blek og SMBarm (messing-grafid), skuggi og ljós brún koma úr vélinni (MAT.brass) */
      /* 24.10 (eigandi, útgáfa 3 "matt milli"): matt fylling felur burstuðu áferðina í stöfunum eins og laserinn, ljós brún neðst og skuggi efst; ramminn eins */
      v.MAT.brass.text = 'rgb(120,96,46)';
      v.MAT.brass.skuggi = '0 -0.05em 0.03em rgba(0,0,0,0.5), 0 0.05em 0 rgba(255,255,255,0.55)';
      v.MAT.brass.sia = 'drop-shadow(0 -0.5px 0.3px rgba(0,0,0,0.5)) drop-shadow(0 0.5px 0 rgba(255,255,255,0.55))';
    }
    if (v.FRAM && v.FRAM.efni) v.FRAM.efni.steelg = 'stal-grafid';
  }
  function liturIdx(v) {
    for (var i = 0; i < v.valkostir.length; i++) if (String(v.valkostir[i].nafn).toLowerCase().indexOf('litur') >= 0) return i;
    return -1;
  }
  function liturGildi(v) {
    var ci = liturIdx(v), ut = [], sed = {};
    if (ci < 0) return ut;
    v.afbrigdi.forEach(function (a) { var x = a.n[ci]; if (x != null && !sed[x]) { sed[x] = 1; ut.push(x); } });
    return ut;
  }
  function hefur(t, o) { return String(t || '').toLowerCase().indexOf(o) >= 0; }
  /* the Litur value of material efni with (m true) or without the treatment, on the steel and brass product:
     steel = "Stal" (no "grafi"), steelg = "... grafi..." with or without "syru", brass = "Mess..." with or without
     "varnar" (VORUBREYTINGAR.md). null when the product has no such value */
  function liturFyrir(v, efni, m) {
    var g = liturGildi(v), f = null;
    g.forEach(function (x) {
      if (f) return;
      if (efni === 'steel' && hefur(x, 'stál') && !hefur(x, 'grafi')) f = x;
      else if (efni === 'steelg' && hefur(x, 'grafi') && hefur(x, 'sýru') === !!m) f = x;
      else if (efni === 'brass' && hefur(x, 'mess') && hefur(x, 'varnar') === !!m) f = x;
    });
    return f;
  }
  function malmVara(ctx) {
    var h = ctx.hd.vel.matHandle('steel'), F = ctx.fjolskylda;
    return h === ctx.vara().handle ? ctx.vara() : F && F.vorur && F.vorur[h];
  }
  /* steelg is offered only when its variant exists (hidden, never shown disabled) */
  function efniTil(ctx, m) {
    if (m !== 'steelg') return true;
    var v = malmVara(ctx);
    return !!(v && liturFyrir(v, 'steelg', false));
  }
  /* the treatment of material efni is offered only when its variant exists */
  function medferdTil(ctx, efni) {
    if (efni !== 'steelg' && efni !== 'brass') return false;
    var v = malmVara(ctx);
    return !!(v && liturFyrir(v, efni, true) && liturFyrir(v, efni, false));
  }
  function medferdNu(ctx) { var hd = ctx.hd, e = hd.cfg.material; return medferdTil(ctx, e) && !!hd.medferd[e]; }
  /* the unit price of the page state with a changed field (size, treatment); the engine state is restored */
  function verdMed(ctx, breyta) {
    var hd = ctx.hd, c = hd.cfg, gamalt = { size: c.size, m: afrita({}, hd.medferd) }, a = null;
    breyta(c, hd.medferd);
    try { a = afbrigdiI(ctx, hd.vel.matHandle(c.material)); } finally { c.size = gamalt.size; hd.medferd = gamalt.m; hd.handle = null; samstillaVoru(ctx); }
    return a ? a.price : null;
  }

  function vantarRamma(ctx) {
    /* metal with a frame on a product that has no Rammi option (today's steel, brass and aluminium data):
       never sold as a free frame (PLAN 3.8 sparse rule; core request 1 in KJARNI-BEIDNIR.md) */
    return vantarRammaEfni(ctx, ctx.hd.cfg.material);
  }
  /* by material: the product of that material (the page's own, or the family's), not the product the
     page shows during a material switch; a product not loaded yet counts as without a Rammi option */
  function vantarRammaEfni(ctx, efni) {
    if (!MALMUR[efni]) return false;
    var h = ctx.hd.vel.matHandle(efni), F = ctx.fjolskylda, v = h === ctx.vara().handle ? ctx.vara() : F && F.vorur && F.vorur[h];
    return !v || rammaValkostur(v) < 0;
  }

  /* ---------- geometry of the plate in its photo cell (fractions of the cell width) ---------- */
  function geo(v, c) {
    var oval = c.shape === 'oval', g = oval ? v.FRAM.oval[c.size] || v.FRAM.oval.M : v.RECT_GEO[c.size] || v.RECT_GEO.M;
    return { top: g.top, h: g.height, w: g.width, left: (1 - g.width) / 2, oval: oval };
  }
  /* 24.10.2026 (eigandi: rammi a malmflisum la a bruninni): rect-steel og rect-brass maeld aftur a utklipptu atlasmyndunum
     (alfarás, platan 0,1588-0,8462 af reitnum, ekki 0,125-0,875), svo flisin = platan og 5 mm rammi lendir eins og i forskodun. */
  /* E5 (2026-09-30): the tile crop, per atlas photo and size column (S, M, L): L, R, T, B in fractions of the cell.
     The plate FACE measured on the full size photos (samraeming/E5-flisar/src/flis_geo.py), inset 3 px of 800
     (acrylic) and past the metal bevel, so the grey tile never shows the white studio edge, the light acrylic
     edge or the shadow band on the right and bottom. The main preview keeps RECT_GEO / FRAM.oval. */
  var FLIS_GEO = {"rect-gold":[[0.13,0.8588,0.3613,0.6525],[0.1313,0.8562,0.2875,0.7338],[0.1288,0.86,0.1812,0.7894]],"rect-silver":[[0.13,0.8575,0.3625,0.6525],[0.1325,0.8575,0.2875,0.7325],[0.1338,0.8625,0.185,0.7913]],"rect-black":[[0.13,0.8594,0.3631,0.65],[0.1325,0.8588,0.2888,0.7306],[0.1269,0.8638,0.1825,0.7894]],"rect-white":[[0.1281,0.8588,0.36,0.6506],[0.13,0.8562,0.2888,0.7306],[0.1256,0.8625,0.1812,0.7875]],"oval-gold":[[0.045,0.9525,0.3475,0.635],[0.0375,0.9494,0.2637,0.7094],[0.04,0.9463,0.1888,0.7875]],"oval-silver":[[0.0375,0.9475,0.3475,0.6362],[0.0375,0.9475,0.265,0.71],[0.035,0.9544,0.1913,0.7875]],"oval-black":[[0.0338,0.9575,0.3475,0.6369],[0.0356,0.9587,0.2637,0.7081],[0.0425,0.9525,0.1881,0.7875]],"oval-white":[[0.035,0.9513,0.3488,0.635],[0.0325,0.955,0.2637,0.7063],[0.0413,0.95,0.1862,0.7875]],"rect-steel":[[0.1619,0.8431,0.3694,0.6544],[0.1619,0.8431,0.3031,0.7294],[0.1619,0.8431,0.2093,0.7719]],"rect-brass":[[0.1619,0.8431,0.3694,0.6544],[0.1619,0.8431,0.3031,0.7294],[0.1619,0.8431,0.2093,0.7719]],"rect-aluminum":[[0.16,0.8413,0.3438,0.6838],[0.16,0.8413,0.3438,0.6838],[0.16,0.8413,0.3438,0.6838]]};
  function geoFlis(v, c) {
    var mat = c.material === 'steelg' ? 'steel' : c.material; /* engraved steel: the same steel photo (E7) */
    var k = (c.shape === 'oval' ? 'oval-' : 'rect-') + mat;
    if (!FLIS_GEO[k]) k = 'rect-' + mat; /* the engine's atlasUrl falls back the same way */
    var t = FLIS_GEO[k], b = t && t[{ S: 0, M: 1, L: 2, AL: 1 }[c.size] || 0];
    if (!b) return geo(v, c);
    return { top: b[2], h: b[3] - b[2], w: b[1] - b[0], left: b[0], oval: k.indexOf('oval-') === 0 };
  }
  /* the tile picture (E5 round 4: sharp AND light). An acrylic tile asks the Shopify CDN for ONLY its plate face
     (crop=region in pixels of the 2400 x 1600 original: size column, frame row and FLIS_GEO crop), at the width
     the widest tile plate of the page needs on this screen, never wider than the original. That width is chosen
     once per page load, so a tile state always has one URL and every step reuses it. Never the main preview's
     2400 sprite: Chrome's downscale of the whole 2400 photo into a small tile lands the frame line 1 to 2 device
     px off centre (white, 1440 px DPR 3), the region crop does not. Metal tiles (theme asset atlases) keep the sprite. */
  var flisN = {};
  function flisThorf(stor) {
    var k = stor ? 's' : 'e';
    if (flisN[k]) return flisN[k];
    /* DPR capped at 2: at DPR 3 the full region crop cost up to +45 % page weight; 2 x 0.8 photo px per CSS px
       (about 0.55 per device px on a DPR 3 screen) still looks sharp there */
    var d = Math.min(2, window.devicePixelRatio || 1), iw = window.innerWidth || 375, mx = 0;
    try { [].forEach.call(document.querySelectorAll('[data-vs-skref]' + (stor ? ':not([data-lykill="efni"])' : '[data-lykill="efni"]') + ' .vs-kostur-mynd'), function (e) { var w = e.getBoundingClientRect().width; if (w > mx) mx = w; }); } catch (e) {}
    /* not laid out yet: the kit's tile widths (phones 2 columns, tablets about 44 %, computers 274 px; the
       material tiles about half of that on tablets and computers) */
    if (!mx) mx = iw < 600 ? (iw - 59) / 2 : iw <= 1000 ? iw * (stor ? 0.44 : 0.21) : stor ? 274 : 129;
    /* the plate is at most 90 % of the tile: its width in device px */
    return (flisN[k] = mx * 0.9 * d);
  }
  /* B6 (2026-10-17): a theme-asset atlas (metal and the acrylic colours, 2400 px, up to 1,3 MB as PNG on older
     iPhones) is drawn in a tile about 110 to 330 css px wide. The tile asks the CDN for a smaller copy (?width=,
     steps of 160 so a page has few URLs): the sprite is 3 plate cells wide, a cell is the plate width / 0.72 (the
     measured plate share of its cell), and the tile picture is the plate width bw (% of the tile) of the widest
     tile of the step at the device pixel ratio (max 2). The main preview keeps the full photo, for the chosen
     material only. */
  function atlasLitid(u, stor, bw) {
    if (!/\/assets\/sm-atlas-[a-z]+-[a-z]+\.webp/.test(u)) return u;
    var w = Math.min(2400, Math.max(480, Math.ceil(3 * flisThorf(stor) * (bw / 90) / 0.72 / 160) * 160));
    if (w >= 2400) return u;
    var q = u.split('?'), v = (q[1] || '').split('&').filter(function (x) { return x && !/^width=/.test(x); });
    v.push('width=' + w);
    return q[0] + '?' + v.join('&');
  }
  function flisMynd(img, gg, stor, bw) {
    var u = String(img.getAttribute('src') || '');
    if (!/\/files\/sm-atlas-[a-z]+-[a-z]+-v4\.jpg/.test(u)) return { sprite: atlasLitid(u, stor, bw || 72) };
    var C = 800, col = Math.round(-parseFloat(img.style.left || 0) / 100) || 0, row = Math.round(-parseFloat(img.style.top || 0) / 100) || 0;
    /* 0.8 photo px per device px looks sharp and keeps the file small (a full size crop is 2 to 3 times the
       bytes: the photo noise). When the page's 1080 sprite (the main preview's own file below computers, so
       usually from cache) already gives that, the tile uses it: no extra file at all. */
    var cw = Math.round(gg.w * C), ch = Math.round(gg.h * C), need = 0.8 * flisThorf(stor);
    if (/[?&]width=1080(&|$)/.test(u) && gg.w * 360 >= need) return { sprite: u };
    need = Math.min(cw, Math.ceil(need / 20) * 20);
    var q = u.split('?'), v = (q[1] || '').split('&').filter(function (x) { return x && !/^(width|height|format|crop[a-z_]*)=/.test(x); });
    v.push('crop=region', 'crop_left=' + Math.round((col + gg.left) * C), 'crop_top=' + Math.round((row + gg.top) * C), 'crop_width=' + cw, 'crop_height=' + ch);
    if (need < cw) v.push('width=' + need);
    v.push('format=webp');
    return { src: q[0] + '?' + v.join('&') };
  }
  /* the plate texture for the letter tiles and the material fallback picture: the inner plate face of the atlas
     photo (sm-flis-efni-<m>.webp, beside sm-sw-<m>.png in assets), never the swatch disc on its white square */
  var FLIS_EFNI_V = {"gold":"be17a58f","silver":"a44ce852","black":"24db1c8f","white":"db47fdde","steel":"13b3d15e","brass":"8576670b","aluminum":"b6004e86"};
  /* the texture is named after the swatch file (steelg uses sm-sw-steel.png, so the steel texture) */
  function flisEfni(hd, m) { var u = String(hd.sw[m] || ''); return u.replace(/sm-sw-([a-z]+)\.png(\?[^"'#]*)?$/, function (a, k) { return FLIS_EFNI_V[k] ? 'sm-flis-efni-' + k + '.webp?v=' + FLIS_EFNI_V[k] : a; }); }
  function mmPlata(c) { var oval = c.shape === 'oval', al = c.size === 'AL'; return { w: (oval || al) ? 150 : 120, h: { S: 50, M: 75, L: 100, AL: 75 }[c.size] || 75 }; }
  function bandSvg(ctx, c, smamynd) {
    /* the engraved band of aluminium, steel and brass: drawn from the numbers the file uses (SMVelSida.rammi) */
    if (!c.border || !MALMUR[c.material] || !window.SMVelSida || !window.SMVelSida.rammi) return '';
    var m = mmPlata(c), g = rammiGeo(c), M = ctx.hd.vel.MAT[c.material];
    var r = window.SMVelSida.rammi(m.w, m.h, { gerd: 'malmur', inset: g.inset, band: g.band, litur: M.text, smamynd: !!smamynd });
    /* 24.10 (eigandi): grafinn rammi fær sömu dýpt og stafirnir (M.sia, aðeins grafið stál og messing) */
    return '<svg class="vs-hurd-band" viewBox="0 0 ' + m.w + ' ' + m.h + '" preserveAspectRatio="none" aria-hidden="true" focusable="false"' + (M.sia && !smamynd ? ' style="filter:' + M.sia + '"' : '') + '>' + r.svg + '</svg>';
  }
  function rammiGeo(c) {
    /* 07.10 (eigandi): málmramminn 5 mm inn frá brún (var 3), bandið 0,5 mm óbreytt */
    if (MALMUR[c.material]) return { gerd: 'malmur', inset: 5, band: 0.5, verd: 'malmur' };
    /* acrylic: the approved door frame, LINA 2,2 mm from the sides and 2,5 mm from top and
       bottom, corners 1,5 mm (the old page, sm-hurda-config.js FRAM.rammi); oval: the ellipse */
    return c.shape === 'oval' ? { gerd: 'lina', inset: 2.2, insetY: 2.5, form: 'sporaskja', verd: 'okeypis' } : { gerd: 'lina', inset: 2.2, insetY: 2.5, r: 1.5, form: 'rett', verd: 'okeypis' };
  }
  /* photo row: row 0 of the atlas has the frame; metal draws its band on the frameless row */
  function syna(c) { var t = {}; afrita(t, c); if (MALMUR[c.material]) t.border = false; return t; }

  /* ---------- tiles ---------- */
  /* the look of one tile state: the tile instance draws it at 480 px, the sizes then go to cqw so the
     names keep their place at any tile size */
  /* the aluminium plate as seen in its photo (fractions of the photo cell, measured 19.10) */
  var AL_SYNILEG = { w: 0.6813, h: 0.34, top: 0.3438 };
  function flisHtml(ctx, c, stadur, stor) {
    var hd = ctx.hd, v = hd.tvel, t = syna(c);
    afrita(hd.tcfg, t);
    v.renderPlate();
    var gg = geoFlis(v, t), sella = hd.tsella, txt = sella.lastChild, img = sella.firstChild;
    var fs = parseFloat(txt.style.fontSize) || 0;
    var stTxt = txt.getAttribute('style').replace(/font-size:\s*[\d.e+-]+px/, 'font-size:' + r4(fs / 480 * 100) + 'cqw');
    var aspect = gg.w / gg.h;
    /* plate width in % of the tile (4:3 box): the size tiles keep one width so the heights compare */
    var bw = stadur ? 72 : Math.min(90, 86 * 3 * aspect / 4);
    var W = 100 / gg.w;
    /* CK 19.10 (QA16 P2): the photo's plate is a little flatter than the sign (S 2,55 : 1 against 120 x 50 mm). The plate box
       takes the sign's own proportions and only the photo stretches to it (about its middle); the letters keep their shape,
       size and place, so preview and file agree in both directions. */
    var mmP = mmPlata(c), sy = aspect / (mmP.w / mmP.h);
    if (!(sy > 0.9 && sy < 1.15) || Math.abs(sy - 1) < 0.005) sy = 1;
    var midja = gg.top + gg.h / 2, raod = Math.round(-parseFloat(img.style.top || 0) / 100) || 0;
    var sellaTopp = sy === 1 ? -gg.top / gg.h * 100 : 50 - midja / (gg.h * sy) * 100;
    var atlasTeygja = sy === 1 ? '' : ';transform:scaleY(' + r4(sy) + ');transform-origin:50% ' + r4((raod + midja) / 2 * 100) + '%';
    /* CK 19.10 (QA16 P0): on aluminium the engine lays the letters on RECT_GEO.AL (0,757 of the photo wide), but the plate seen in
       sm-atlas-rect-al.webp is 0,681 wide (measured 0,160-0,841 x 0,344-0,684): the letters shrink to it about the plate's middle.
       Only the picture changes; the engine and the production file keep their numbers. */
    var alGeo = c.size === 'AL' && v.RECT_GEO && v.RECT_GEO.AL, alK = alGeo ? AL_SYNILEG.w / alGeo.width : 1;
    var textiKvardi = alK !== 1 ? ';transform:scale(' + r4(alK) + ');transform-origin:50% ' + r4((alGeo.top + alGeo.height / 2) * 100) + '%' : '';
    var rad = gg.oval ? '50%' : r4(1.5 / mmPlata(c).w * 100) + '%/' + r4(1.5 / mmPlata(c).h * 100) + '%';
    var mynd = flisMynd(img, gg, stor, bw);
    return '<span class="vs-hurd-flis"><span class="vs-hurd-plata" style="width:' + r4(bw) + '%;aspect-ratio:' + r4(aspect / sy) + ';border-radius:' + rad + '">' +
      (mynd.src ? '<img class="vs-hurd-flis-mynd" alt="" loading="lazy" decoding="async" src="' + esc(mynd.src) + '" style="position:absolute;left:0;top:0;width:100%;height:100%;max-width:none;max-height:none;object-fit:fill;margin:0;padding:0;border:0;border-radius:0">' : '') +
      '<span data-hurd-sella class="' + esc(sella.className) + '" style="width:' + r4(W) + '%;left:' + r4(-gg.left * W) + '%;top:' + r4(sellaTopp) + '%">' +
      (mynd.src ? '' : '<img class="vs-hurd-atlas" alt="" loading="lazy" decoding="async" src="' + esc(mynd.sprite) + '" style="left:' + esc(img.style.left) + ';top:' + esc(img.style.top) + atlasTeygja + '">') +
      '<span class="vs-hurd-texti" style="' + esc(stTxt + textiKvardi) + '">' + txt.innerHTML + '</span></span>' + bandSvg(ctx, c, true) + '</span></span>';
  }
  /* the state a tile shows: the page state with the tile's value (and the frame it would get) */
  function flisCfg(ctx, s2, o) {
    var hd = ctx.hd, c = afrita({}, hd.cfg), v = hd.tvel;
    if (s2.letur && LETUR[s2.letur]) c.font = LETUR[s2.letur];
    if (o.lykill === 'efni') {
      /* the engine's material rules on a copy (the tile instance's cfg) */
      afrita(hd.tcfg, c);
      setjaEfni(v, hd.tcfg, o.gildi);
      c = afrita({}, hd.tcfg);
      c.border = rammiNu(ctx, s2, o.gildi) === 'med';
    } else if (o.lykill === 'logun') c.shape = o.gildi;
    else if (o.lykill === 'staerd') c.size = o.gildi;
    if (s2.skraut != null) c.skraut = s2.skraut === SK_TIGLAR;
    if (o.tegund === 'rammi') c.border = s2.rammi === 'med';
    else if (o.lykill !== 'efni') c.border = rammiNu(ctx, s2) === 'med';
    return c;
  }
  function flisLykill(c) { return JSON.stringify([c.material, c.shape, c.size, c.border, c.font, c.names, c.includeAddress ? c.address : null, c.skraut ? 1 : 0]); }

  /* ---------- steps (sersnid bodies) ---------- */
  function tengja(el, fn) {
    if (el.__hdTengt) return;
    el.__hdTengt = true;
    el.addEventListener('change', function (e) { var t = e.target; if (t && t.type === 'radio') fn(t.value); });
  }
  function nafnaTexti(ctx) {
    var n = ctx.hd.vel.nameCount();
    return n ? ord(ctx, n === 1 ? 'nafn_1' : 'nofn_n', { n: n }) : '';
  }
  function malTexti(v, c) { var s = v.SIZES[c.size]; return (c.shape === 'oval' && s.oval) ? s.oval : s.dim; }
  /* owner 07.10: at most 10 names on one door sign; more is a special order (mail). The size only grows by
     itself (staekka). Lines past the 10th filled line are not taken. */
  var NAFNAHAMARK = 10, HAMARK_POSTUR = 'sm@skiltiogmerkingar.is';
  /* owner 18.10 (102 orders, longest name 33): at most 36 characters on a name line. The engine shrinks the letters to the
     width and a line never wraps (.vs-hurd-texti .name nowrap); past 36 the page stops with villa_lina_long and nothing
     goes to the cart. The address line keeps its own cap (32). */
  var LINUHAMARK = 36;
  function ofLong(t) { var l = String(t == null ? '' : t).split('\n'); for (var i = 0; i < l.length; i++) if (stafir(trim(l[i])) > LINUHAMARK) return true; return false; }
  function takmarkaNofn(t) {
    var l = String(t == null ? '' : t).split('\n'), n = 0, ut = [], i;
    for (i = 0; i < l.length; i++) {
      if (trim(l[i])) { if (n >= NAFNAHAMARK) break; n++; }
      ut.push(l[i]);
    }
    return ut.join('\n');
  }
  /* ---------- takka-hamur (prufa ?view=prufa, section setting "takkar" -> data-takkar on .vs) ----------
     Rammi, Skraut, Heimilisfang, Sporoskjulaga and (15.10) Efni of the steel and brass product become on/off pills on the live preview. They drive exactly the
     state the steps drive (the frame and ornament radios, the address switch, the shape radios), so price, variant,
     cart properties and production file are unchanged. The four steps stay in the DOM (state is read from them) but
     are marked data-takka-fel: hidden by CSS and skipped by the step numbering. Without data-takkar none of this runs. */
  function erTakkar(ctx) { return !!(ctx && ctx.rot && ctx.rot.hasAttribute && ctx.rot.hasAttribute('data-takkar')); }
  function takkaRadios(ctx, l) { var s = ctx.skref(l); return s && s.el ? Array.prototype.slice.call(s.el.querySelectorAll('input[type=radio]')) : []; }
  function takkaRadio(ctx, l, f) { var r = takkaRadios(ctx, l); for (var i = 0; i < r.length; i++) if (f(r[i])) return r[i]; return null; }
  /* 15.10: Efni on the steel and brass product as a pair of pills (Stal, svartir stafir | Stal, grafid | Messing). A pill shows only when the
     product has its Litur variant (liturFyrir) and the efni step has its tile; never on acrylic or aluminium (their material is not one of these
     three), and never one pill alone (a step with one real choice is hidden, owner rule). Not offered = hidden, never grey. */
  var MALM3 = ['steel', 'steelg', 'brass'], MALM3_ER = { steel: 1, steelg: 1, brass: 1 };
  function efniTakkiEitt(ctx, m) {
    var v = malmVara(ctx);
    return !!(v && (liturFyrir(v, m, false) || liturFyrir(v, m, true)) && takkaRadio(ctx, 'efni', function (x) { return x.value === m; }));
  }
  function efniTakkiTil(ctx, m) {
    if (!MALM3_ER[ctx.hd.cfg.material] || !efniTakkiEitt(ctx, m)) return false;
    return MALM3.filter(function (x) { return efniTakkiEitt(ctx, x); }).length >= 2;
  }
  function takkaSmida(ctx) {
    var hd = ctx.hd, c = hd.cfg, rodin = ctx.rammi;
    if (!rodin || hd.takkarBar) return;
    ['rammi', 'skraut', 'logun'].forEach(function (l) {
      var s = ctx.skref(l);
      if (s && s.el) s.el.setAttribute('data-takka-fel', '');
      var a = ctx.rot.querySelector('[data-vs-stika="' + l + '"]'), li = a && a.closest ? a.closest('li') : null;
      if (li) li.setAttribute('data-takka-fel', '');
    });
    var bar = document.createElement('div');
    bar.className = 'vs-hurd-takkar';
    bar.setAttribute('role', 'group');
    /* Læsileiki 21.10: hópurinn heitir það sama og fyrirsögnin á röndinni (ctx.t = tungumál síðunnar, íslenska er sjálfgefin) */
    bar.setAttribute('aria-label', ctx.t('takkar_haus') || 'Prófaðu á skiltinu');
    /* pressed / available / click per pill; the radios and the address switch are the ones of the steps */
    var T = [
      { k: 'rammi', t: ord(ctx, 'takki_rammi') || ctx.t('rammi') || 'Rammi',
        til: function () { var s = ctx.skref('rammi'); return !!(s && s.synilegt); },
        kv: function () { var r = takkaRadio(ctx, 'rammi', function (x) { return x.checked; }); return !!r && r.value === 'med'; },
        smella: function (kv) { var r = takkaRadio(ctx, 'rammi', function (x) { return x.value === (kv ? 'an' : 'med'); }); if (r) r.click(); } },
      { k: 'skraut', t: ord(ctx, 'takki_skraut') || ctx.eiginleiki('skraut') || 'Skraut',
        til: function () { var s = ctx.skref('skraut'); return !!(s && s.synilegt) && !c.includeAddress; },
        kv: function () { var r = takkaRadio(ctx, 'skraut', function (x) { return x.checked; }); return !!r && r.value === SK_TIGLAR; },
        smella: function (kv) { var r = takkaRadio(ctx, 'skraut', function (x) { return kv ? x.value !== SK_TIGLAR : x.value === SK_TIGLAR; }); if (r) r.click(); } },
      { k: 'heim', t: ord(ctx, 'takki_heim') || 'Heimilisfang / íbúð',
        til: function () { return true; },
        kv: function () { return !!c.includeAddress; },
        smella: function () {
          var r = ctx.rot.querySelector('[data-hd-rofi]'); if (r) r.click();
          /* 14.10: kveikt = skruna ad reitnum og baendill i hann (reiturinn birtist vid teikningu, reynt aftur ef hann er enn falinn) */
          if (!c.includeAddress) return;
          var fara = function (sidast) {
            var f = ctx.rot.querySelector('[data-hd-inn="heim"]');
            if (!f || !f.offsetParent) { if (!sidast) setTimeout(function () { fara(true); }, 150); return; }
            /* CK 19.10 (QA1): below the sticky preview on a phone (ctx.synaReit), centred on a computer */
            if (ctx.synaReit && window.innerWidth < 1001) ctx.synaReit(f);
            else { try { f.scrollIntoView({ block: 'center', behavior: 'smooth' }); } catch (e) { try { f.scrollIntoView(); } catch (e2) {} } }
            try { f.focus({ preventScroll: true }); } catch (e3) {}
          };
          fara(false);
        } },
      /* 13.10: logunin er par (Ferhyrnt | Sporoskjulaga), ekki einn rofi; bada pillur fela sig thegar efnid a enga sporoskju */
      { k: 'rett', par: 'logun', t: ord(ctx, 'ferhyrnt') || 'Ferhyrnt',
        til: function () { var s = ctx.skref('logun'); return !!(s && s.synilegt) && !hd.vel.MAT[c.material].noOval; },
        kv: function () { return c.shape !== 'oval'; },
        smella: function () { var r = takkaRadio(ctx, 'logun', function (x) { return x.value === 'rect'; }); if (r) r.click(); } },
      { k: 'oval', par: 'logun', t: ord(ctx, 'sporaskja') || 'Sporöskjulaga',
        til: function () { var s = ctx.skref('logun'); return !!(s && s.synilegt) && !hd.vel.MAT[c.material].noOval; },
        kv: function () { return c.shape === 'oval'; },
        smella: function () { var r = takkaRadio(ctx, 'logun', function (x) { return x.value === 'oval'; }); if (r) r.click(); } }
    ];
    /* 15.10: Efni a malmvorunni sem par; smellir a flis efnisskrefsins (sama radio og skrefid, engin eigin stada) */
    MALM3.forEach(function (m) {
      T.push({ k: 'efni-' + m, par: 'efni', t: m === 'brass' ? (ord(ctx, 'synp_brass') || 'Messing') : efniSynStutt(ctx, m),
        til: function () { return efniTakkiTil(ctx, m); },
        kv: function () { return c.material === m; },
        smella: function () { var r = takkaRadio(ctx, 'efni', function (x) { return x.value === m; }); if (r && !r.checked) r.click(); } });
    });
    /* 13.10: rondin fer undir myndina (SMTakkarSmida i sm-vel-sida.js); varaleid an hennar er gamla stadan nedst a myndinni */
    var rod = window.SMTakkarSmida ? window.SMTakkarSmida(bar, rodin, { haus: ctx.t('takkar_haus'), stutt: ctx.t('takkar_stutt'), leid: ctx.t('takkar_leid') }) : null, par = {};
    if (!rod) {
      var mb0 = rodin.querySelector('[data-vs-malband]');
      if (mb0 && mb0.parentNode === rodin) rodin.insertBefore(bar, mb0.nextSibling); else rodin.appendChild(bar);
      rod = bar;
    }
    T.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'vs-hurd-takki';
      b.setAttribute('data-hd-takki', p.k);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = p.t;
      /* eigandi 21.10: "Heimilisfang / íbúð" alltaf í tveimur línum, eins og á sýnisíðu bólunnar (línuskil á eftir skástrikinu) */
      if (p.k === 'heim' && p.t.indexOf(' / ') > 0) { b.innerHTML = esc(p.t.replace(/ \/ /, ' /')).replace(' /', ' /<br>'); b.title = p.t; }
      b.addEventListener('click', function () { p.smella(p.kv()); });
      p.el = b;
      var inn = rod;
      if (p.par) {
        if (!par[p.par]) {
          var w = document.createElement('div');
          w.className = 'vs-takka-par';
          w.setAttribute('role', 'group');
          w.setAttribute('aria-label', ord(ctx, p.par) || ({ logun: 'Lögun', efni: 'Efni' })[p.par] || p.par);
          rod.appendChild(w);
          par[p.par] = w;
        }
        inn = par[p.par];
      }
      inn.appendChild(b);
    });
    hd.takkarBar = { el: bar, T: T, par: par, lina: null };
    /* Læsileiki 21.10 (A P1 í valkostabola-2026-10-21): parið skiptir um vöru og verð án þess að segja það; ein lína undir síðasta parinu
       segir stærð og verð þess sem er valið, úr gögnum vörunnar (SIZES og verð afbrigðisins, sama og stærðarskrefið sýnir). aria-live les hana. */
    var sidastaPar = null;
    Object.keys(par).forEach(function (k) { sidastaPar = par[k]; });
    if (sidastaPar) {
      var lina = document.createElement('span');
      lina.className = 'vs-takka-par-lina';
      lina.id = 'vs-' + ctx.id + '-par-lina';
      lina.setAttribute('aria-live', 'polite');
      sidastaPar.appendChild(lina);
      sidastaPar.setAttribute('aria-describedby', lina.id);
      hd.takkarBar.lina = lina;
    }
    if (rod === bar && window.SMTakkarSkrun) window.SMTakkarSkrun(bar);
  }
  function takkaUppfaera(ctx) {
    var tb = ctx.hd && ctx.hd.takkarBar;
    if (!tb) return;
    tb.T.forEach(function (p) {
      var til = p.til(), kv = til && p.kv();
      if (p.el.hidden !== !til) p.el.hidden = !til;
      var v = kv ? 'true' : 'false';
      if (p.el.getAttribute('aria-pressed') !== v) p.el.setAttribute('aria-pressed', v);
    });
    Object.keys(tb.par || {}).forEach(function (k) {
      var w = tb.par[k], allt = tb.T.every(function (p) { return p.par !== k || p.el.hidden; });
      if (w.hidden !== allt) w.hidden = allt;
    });
    /* 15.10: the efni step is hidden (data-takka-fel) only when it has at most 3 tiles and a shown pill covers each one; on the steel and
       brass page it also holds the acrylic and aluminium tiles (7), so it stays */
    var es = ctx.skref('efni');
    if (es && es.el) {
      var rr = takkaRadios(ctx, 'efni'), fel = rr.length > 0 && rr.length <= 3 && rr.every(function (r) {
        return tb.T.some(function (p) { return p.k === 'efni-' + r.value && !p.el.hidden; });
      });
      var ea = ctx.rot.querySelector('[data-vs-stika="efni"]'), eli = ea && ea.closest ? ea.closest('li') : null;
      [es.el, eli].forEach(function (x) { if (x && x.hasAttribute('data-takka-fel') !== fel) { if (fel) x.setAttribute('data-takka-fel', ''); else x.removeAttribute('data-takka-fel'); } });
    }
    if (tb.lina) {
      /* línan fylgir því pari sem sést (efnisparið er síðast í DOM en falið á akrýli og áli) */
      var heimaPar = null;
      Object.keys(tb.par || {}).forEach(function (k) { if (!tb.par[k].hidden) heimaPar = tb.par[k]; });
      if (heimaPar && tb.lina.parentNode !== heimaPar) { heimaPar.appendChild(tb.lina); heimaPar.setAttribute('aria-describedby', tb.lina.id); }
      var c2 = ctx.hd.cfg, S2 = (ctx.hd.vel.SIZES || {})[c2.size] || {}, mal = (c2.shape === 'oval' && S2.oval) ? S2.oval : S2.dim, verd = null;
      try { verd = verdMed(ctx, function () {}); } catch (e) { verd = null; }
      var lt = (mal ? mal + ' cm' : '') + (verd == null ? '' : (mal ? ' \u00b7 ' : '') + kr(verd));
      if (tb.lina.textContent !== lt) tb.lina.textContent = lt;
    }
    if (tb.el.__skrun) tb.el.__skrun();
  }

  var SKREF = {
    nofn: {
      teikna: function (el, s, ctx) {
        var hd = ctx.hd, c = hd.cfg;
        if (!el.__hdReitir) {
          el.__hdReitir = true;
          var id = 'vs-' + ctx.id + '-hd-';
          /* kit units (K-reitur, K-bod, K-rofi): ids, data-hd-inn and data-hd-rofi as before; the names box is the
             textarea form of K-reitur (aria-describedby = its help line), the address field is hidden until the
             switch is on, the limit note sits inside the names field in a status region */
          c.names = takmarkaNofn(c.names);
          var hamarkBod = ctx.html.bod('', 'hjalp', { html: esc(ord(ctx, 'nofn_hamark', { n: NAFNAHAMARK })) +
            ' <a href="mailto:' + esc(HAMARK_POSTUR) + '">' + esc(HAMARK_POSTUR) + '</a>.', falid: true, live: 'off', klasi: 'vs-hurd-hamark', gogn: { 'hd-hamark': true } });
          var nofnReitur = ctx.html.reitur({ id: id + 'nofn', heiti: ord(ctx, 'nofn_heiti'), gerd: 'svaedi', linur: 4, skylda: true, villa: false,
            synishorn: ord(ctx, 'nofn_synishorn'), gildi: c.names, hjalp: ord(ctx, 'nofn_hjalp'), inntakKlasi: 'vs-hurd-nofn',
            attr: { autocomplete: 'off', autocapitalize: 'words', spellcheck: 'false' }, gogn: { 'hd-inn': 'nofn' } })
            .replace(/<\/div>$/, '<div role="status" aria-live="polite">' + hamarkBod + '</div></div>');
          var heimReitur = ctx.html.reitur({ id: id + 'heim', heiti: ord(ctx, 'heim_heiti'), hamark: 32, villa: false, falid: true,
            synishorn: hd.vel.SAMPLE_ADDR, gildi: c.address, attr: { autocomplete: 'off', spellcheck: 'false' },
            gogn: { 'hd-inn': 'heim' }, reitGogn: { 'hd-heim': true } });
          ctx.html.setja(el, ctx.html.reitir([heimReitur, nofnReitur]) +
            ctx.html.rofi({ heiti: ord(ctx, 'heim_rofi'), valid: !!c.includeAddress, fokus: id + 'rofi', gogn: { 'hd-rofi': true } }));
          var nofn = el.querySelector('[data-hd-inn="nofn"]'), heim = el.querySelector('[data-hd-inn="heim"]'), rofi = el.querySelector('[data-hd-rofi]');
          var hamark = el.querySelector('[data-hd-hamark]');
          if (erTakkar(ctx) && rofi && rofi.closest && rofi.closest('label')) rofi.closest('label').setAttribute('data-takka-fel', '');
          el.__hdHamark = function () { if (hamark) hamark.hidden = hd.vel.nameCount() < NAFNAHAMARK; };
          nofn.value = c.names;
          heim.value = c.address;
          var bid = 0, sidastLykill = null;
          /* one sync per frame while typing. The whole page (variant, step values, errors, bar) only when
             something it shows changed: the size (staekka grows it with the names), the number of names, an
             empty or filled address, a character that cannot be engraved. Otherwise the preview and the
             tiles only (one drawing per key, as the old page), so typing stays light on phones */
          var seinna = function () {
            if (bid) return;
            bid = (window.requestAnimationFrame || setTimeout)(function () {
              bid = 0;
              var k = [c.size, hd.vel.nameCount(), !!trim(c.address), c.includeAddress, TJAKN.test(c.names + c.address), ofLong(c.names)].join('|');
              if (k !== sidastLykill) { sidastLykill = k; ctx.breytt(); }
              ctx.teiknaAftur();
            });
          };
          nofn.addEventListener('input', function () {
            var nytt = nofn.value, v = takmarkaNofn(nytt);
            if (v !== nytt) {
              /* a typed key or Enter past the 10th name: undo just that key, the caret stays where it was.
                 A paste: keep the first 10 names */
              var p = nofn.selectionStart == null ? nytt.length : nofn.selectionStart, d = nytt.length - String(c.names).length;
              if (d > 0 && d <= 2) { v = c.names; p = Math.max(0, p - d); } else p = v.length;
              nofn.value = v;
              try { nofn.setSelectionRange(p, p); } catch (e) {}
            }
            /* owner 07.10 (second rule of the day): the first character in an EMPTY names box (the sample names go away)
               sets the size to Litid, then staekka grows it with the names (Mid from 3, Stort from 6); it never
               shrinks while typing and a size the customer picked (sizeManual) is never touched. Before typing the
               sample keeps the size it has. Aluminium has one size (fixedSize) and is skipped. */
            if (!trim(c.names) && trim(v) && !c.sizeManual && !hd.vel.MAT[c.material].fixedSize && STAERDIR.indexOf(c.size) >= 0) c.size = 'S';
            c.names = v; staekka(hd.vel, c); hd.vel.framForhlada(); el.__hdHamark(); seinna();
          });
          heim.addEventListener('input', function () { c.address = heim.value; seinna(); });
          rofi.addEventListener('change', function () {
            c.includeAddress = !!rofi.checked;
            /* owner 08.10: no Skraut with an address; the step is hidden (syna) and goes back to Ekkert */
            if (c.includeAddress) { var sks = ctx.skref('skraut'); if (sks && sks.el) Array.prototype.forEach.call(sks.el.querySelectorAll('input[type=radio]'), function (r) { r.checked = r.value !== SK_TIGLAR; }); c.skraut = false; }
            hd.vel.framForhlada();
            ctx.breytt();
            if (c.includeAddress) try { heim.focus(); } catch (e) {}
          });
        }
        var r = el.querySelector('[data-hd-rofi]'), f = el.querySelector('[data-hd-heim]');
        if (el.__hdHamark) el.__hdHamark();
        if (r) r.checked = !!c.includeAddress;
        if (f) f.hidden = !c.includeAddress;
      },
      gildi: function (s, ctx) { return nafnaTexti(ctx); },
      buid: function (s, ctx) { var c = ctx.hd.cfg; return ctx.hd.vel.nameCount() > 0 && (!c.includeAddress || !!trim(c.address)) && !TJAKN.test(c.names + c.address) && !ofLong(c.names); },
      fokus: function (el, kodi) { return kodi === 'heimilisfang' ? el.querySelector('[data-hd-inn="heim"]') : el.querySelector('[data-hd-inn="nofn"]'); }
    },
    efni: {
      teikna: function (el, s, ctx) {
        var hd = ctx.hd, v = hd.vel, c = hd.cfg;
        var k = EFNI.filter(function (m) { return efniTil(ctx, m); }).map(function (m) {
          var M = v.MAT[m], min = v.matMin(m), ak = M.fam === 'akryl', vs = v.matVerd ? v.matVerd(m, c.size) : null;
          return { gildi: m, heiti: efniSynStutt(ctx, m), nafn: M.name, valid: c.material === m, hopur: ord(ctx, ak ? 'hopur_akryl' : 'hopur_malmar'),
            hopur_skyring: ord(ctx, ak ? 'hopur_akryl_s' : 'hopur_malmar_s'), undir: vs != null ? kr(vs) : (min == null ? '' : ord(ctx, 'fra', { p: kr(min) })),
            mynd: hd.sw[m] ? '<img src="' + esc(flisEfni(hd, m)) + '" alt="" loading="lazy">' : '', ak: ak };
        });
        /* owner addendum 2026-09-30: the description (and its treatment check box) sit directly under the
           row the chosen material is drawn in, acrylic or metal, never after both rows */
        var e = c.material, erAk = v.MAT[e].fam === 'akryl';
        var akRod = k.filter(function (x) { return x.ak; }), malmRod = k.filter(function (x) { return !x.ak; });
        var lina = ord(ctx, 'um_' + (erAk ? 'akryl' : e)), efnisheiti = efniSyn(ctx, e), mf = '';
        if (medferdTil(ctx, e)) {
          var d = verdMed(ctx, function (c2, m2) { m2[e] = true; }) - verdMed(ctx, function (c2, m2) { m2[e] = false; });
          var lyk = e === 'brass' ? 'varnar' : 'syru', hid = 'vs-' + ctx.id + '-hd-mf';
          mf = ctx.html.rofi({ gildi: e, valid: !!hd.medferd[e], fokus: hid + '-' + e, lysing: hid, ytraGogn: { 'hd-medferd': true }, klasi: 'vs-hurd-mf',
              html: esc(ord(ctx, 'mf_' + lyk)) + (d > 0 ? ' <b class="vs-rofi-verd">+' + esc(kr(d)) + '</b>' : '') }) +
            ctx.html.bod(ord(ctx, 'mf_' + lyk + '_s'), 'hjalp', { id: hid, live: 'off' });
        }
        var undirRod = (lina ? ctx.html.bod('', 'hjalp', { html: '<b>' + esc(efnisheiti) + '.</b> ' + esc(lina), live: 'off', klasi: 'vs-bod--rond vs-hurd-efnilina', gogn: { 'hd-efnilina': true } }) : '') + mf;
        var html = ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-hd-efni', birting: 'utlit', lykill: 'efni', kostir: akRod }) +
          (erAk ? undirRod : '') +
          ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-hd-efni', birting: 'utlit', lykill: 'efni', kostir: malmRod }) +
          (erAk ? '' : undirRod);
        ctx.html.setja(el, html);
        tengja(el, function (m) { if (!v.MAT[m] || m === c.material) return; setjaEfni(v, c, m); ctx.breytt(); });
        if (!el.__hdMf) {
          el.__hdMf = true;
          el.addEventListener('change', function (ev) {
            var t = ev.target;
            if (!t || t.type !== 'checkbox' || !t.closest || !t.closest('[data-hd-medferd]')) return;
            hd.medferd[t.value] = !!t.checked;
            ctx.breytt();
          });
        }
      },
      gildi: function (s, ctx) { var e = ctx.hd.cfg.material; return e === 'steel' || e === 'steelg' ? efniSynStutt(ctx, e) : efniSyn(ctx, e); }
    },
    logun: {
      teikna: function (el, s, ctx) {
        var hd = ctx.hd, c = hd.cfg;
        var k = [{ gildi: 'rect', heiti: ord(ctx, 'ferhyrnt'), valid: c.shape !== 'oval' }, { gildi: 'oval', heiti: ord(ctx, 'sporaskja'), valid: c.shape === 'oval' }];
        ctx.html.setja(el, ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-hd-logun', birting: 'utlit', lykill: 'logun', kostir: k }));
        tengja(el, function (f) { if (f === c.shape || (f === 'oval' && hd.vel.MAT[c.material].noOval)) return; c.shape = f; ctx.breytt(); });
      },
      gildi: function (s, ctx) { return ord(ctx, ctx.hd.cfg.shape === 'oval' ? 'sporaskja' : 'ferhyrnt'); }
    },
    staerd: {
      teikna: function (el, s, ctx) {
        var hd = ctx.hd, v = hd.vel, c = hd.cfg, keys = v.sizeKeys();
        /* E7: small buttons on one line, the size and its price with the page's other choices */
        var k = keys.map(function (z) {
          var S = v.SIZES[z], p = verdMed(ctx, function (c2) { c2.size = z; });
          return { gildi: z, heiti: ord(ctx, 'staerd_' + z) || S.name, undir: ((c.shape === 'oval' && S.oval) ? S.oval : S.dim) + (p == null ? '' : ' · ' + kr(p)), valid: c.size === z };
        });
        var html = ctx.html.kostir({ nafn: 'vs-' + ctx.id + '-hd-staerd', birting: 'pillur', klasi: 'vs-hurd-staerd vs-val--einlina', dalkar: keys.length, kostir: k }) +
          ctx.html.bod('', 'hjalp', { live: 'off', gogn: { 'hd-sjalf': true } }) + ctx.html.bod('', 'vidvorun', { gogn: { 'hd-vidv': true } });
        ctx.html.setja(el, html);
        tengja(el, function (z) { if (!v.SIZES[z]) return; c.size = z; c.sizeManual = true; ctx.breytt(); });
        /* the old page's lines under the sizes (sm-hurda-config.js renderUI, same rules) */
        var n = v.nameCount(), sj = el.querySelector('[data-hd-sjalf]'), vv = el.querySelector('[data-hd-vidv]'), t = '';
        if (keys.length < 2) t = '';
        else if (!c.sizeManual && STAERDIR.indexOf(c.size) > 0 && n > v.SIZES[STAERDIR[STAERDIR.indexOf(c.size) - 1]].rec) t = ord(ctx, 'sjalf_n', { n: n });
        else if (!c.sizeManual) t = ord(ctx, 'sjalf_bid');
        ctx.html.bodSetja(sj, t, 'hjalp');
        var w = '', S = v.SIZES[c.size];
        var midDim = (c.shape === 'oval' && v.SIZES.M.oval) ? v.SIZES.M.oval : v.SIZES.M.dim;
        if (c.size === 'S' && c.includeAddress && n >= 3 && keys.indexOf('M') >= 0) w = ord(ctx, 'vidv_litid', { n: n, d: midDim });
        else if (c.sizeManual && n > S.rec) w = ord(ctx, 'vidv_fjoldi', { n: n, s: (ord(ctx, 'staerd_' + c.size) || S.name).toLowerCase(), r: S.rec });
        ctx.html.bodSetja(vv, w, 'vidvorun');
      },
      gildi: function (s, ctx) { var v = ctx.hd.vel, c = ctx.hd.cfg; return (ord(ctx, 'staerd_' + c.size) || v.SIZES[c.size].name) + ', ' + malTexti(v, c) + ' cm'; }
    }
  };

  /* the tile name: steel in two forms ("Stal, svartir stafir" / "Stal, grafid"), the others as the engine.
     brass is always engraved too, but its short label comes from grafid()'s override of v.MAT.brass.short,
     so the plain MAT[m].short fallback below already reads "Messing, grafid" for it. */
  function efniMerki(ctx, m) {
    var t = m === 'steel' || m === 'steelg' ? ord(ctx, 'merki_' + m) : '';
    return t || ctx.hd.vel.MAT[m].short;
  }
  /* FK 21.10: the material names as SHOWN outside Icelandic (ord syn_ = full name, synk_ = short tile name; empty on /). The Icelandic
     MAT name stays the data-nafn and the cart property "Efni og litur"; only the shown text is translated. */
  function efniSyn(ctx, m) { return ord(ctx, 'syn_' + m) || ctx.hd.vel.MAT[m].name; }
  function efniSynStutt(ctx, m) { return ord(ctx, 'synk_' + m) || efniMerki(ctx, m); }
  /* 07.10 (owner): the notes step is the kit's own, the same on every product page (heading, Valfrjalst, the box
     always open); the E7 Nei / Ja switch is gone. */
  /* ---------- letter tiles: the text box of a tile, the font, the fit ---------- */
  var simiMidill = window.matchMedia ? window.matchMedia('(max-width: 760px)') : null;
  function leturCss(ctx, id) {
    var f = ctx.hd.vel.FONTS[LETUR[id]];
    return f ? { fontFamily: f.css, fontWeight: String(f.w), fontStyle: 'normal' } : { fontFamily: '', fontWeight: '400', fontStyle: 'normal' };
  }
  function leturBox(ctx) {
    var sk = ctx.skref('letur'), b = sk && sk.el ? sk.el.querySelector('[data-vs-letur]') : null;
    var simi = !!(simiMidill && simiMidill.matches);
    /* the tile's box less its 6 px side padding; before layout the phone or desktop box of the kit CSS */
    var w = b ? b.clientWidth - 12 : 0, h = b ? b.clientHeight : 0;
    return { w: w > 20 ? w : (simi ? 120 : 110), h: h > 20 ? h : (simi ? 48 : 56), simi: simi };
  }
  var leturBidur = {};
  function leturTilbuid(ctx, id) {
    var c = leturCss(ctx, id);
    if (!c.fontFamily || !document.fonts || !document.fonts.check) return true;
    var spec = c.fontWeight + ' 22px ' + c.fontFamily, ok = false;
    try { ok = document.fonts.check(spec); } catch (e) { ok = true; }
    if (!ok && !leturBidur[spec] && document.fonts.load) {
      /* measured with the fallback font until the webfont is in; then the tiles are measured again */
      leturBidur[spec] = 1;
      document.fonts.load(spec).then(function () { try { ctx.flisar(); } catch (e2) {} }, function () {});
    }
    return ok;
  }
  var maeliCanvas = null;
  function breidd(texti, px, c) {
    if (!maeliCanvas) maeliCanvas = document.createElement('canvas').getContext('2d');
    if (!maeliCanvas) return texti.length * px * 0.6;
    maeliCanvas.font = (c.fontStyle === 'italic' ? 'italic ' : '') + c.fontWeight + ' ' + px + 'px ' + (c.fontFamily || 'sans-serif');
    return maeliCanvas.measureText(texti).width;
  }
  /* the fit: [lines], px. Widths scale with the size, so each is measured once at the start size */
  function leturMal(texti, c, b) {
    /* E6 2026-09-30: tile factor for the script style set to 1.0 (a verifier found 1.03 made tiles ~6% too big) */
    var st = (b.simi ? 20 : 22) * (c.fontFamily && c.fontFamily.indexOf('Dancing') >= 0 ? 1.0 : 1), W = b.w * 0.97, lh = 1.12;
    var w1 = breidd(texti, st, c);
    if (w1 <= W) return { linur: [texti], px: st };
    var p1 = Math.floor(st * W / w1);
    var ord2 = texti.split(/\s+/);
    if (p1 >= 17 || ord2.length < 2) return { linur: [texti], px: Math.max(p1, 15) };
    var besta = null;
    for (var i = 1; i < ord2.length; i++) {
      var a = ord2.slice(0, i).join(' '), z = ord2.slice(i).join(' ');
      var m = Math.max(breidd(a, st, c), breidd(z, st, c));
      if (!besta || m < besta.m) besta = { a: a, z: z, m: m };
    }
    var p2 = Math.min(st, Math.floor(st * W / besta.m), Math.floor((b.h - 4) / (2 * lh)));
    /* two lines when that is larger than the one line size; the floor is 14 px, then "..." per line */
    if (p2 > p1) return { linur: [besta.a, besta.z], px: Math.max(p2, 14) };
    return { linur: [texti], px: Math.max(p1, 15) };
  }
  function leturFlis(ctx, id, texti) {
    var c = leturCss(ctx, id), b = leturBox(ctx), t = trim(texti), m = leturMal(t, c, b);
    return '<span class="vs-hurd-lt" data-hd-linur="' + m.linur.length + '" style="font-family:' + esc(c.fontFamily) + ';font-weight:' + esc(c.fontWeight) +
      ';font-size:' + m.px + 'px">' + m.linur.map(function (l) { return '<span>' + esc(l) + '</span>'; }).join('') + '</span>';
  }

  var A = {
    gerd: 'dom',
    fylla: true,
    skuggi: true,
    lifandi: true,
    skref: SKREF,
    upphaf: function (ctx) {
      var hd = byrja(ctx), c = hd.cfg, v = hd.vel;
      /* the frame defaults of the block (the kit's rule, read before its step settles) */
      var sk = ctx.skref('rammi');
      if (sk && sk.el) {
        hd.sjalf = sk.el.getAttribute('data-sjalfgefid') === 'an' ? 'an' : 'med';
        hd.malmSjalf = sk.el.getAttribute('data-sjalfgefid-malmur') === 'med' ? 'med' : 'an';
        sk.el.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') hd.snert = true; }, true);
        /* the approved metal frame copy as the block printed it (never edited here, only hidden, see hjalp) */
        var hj = sk.el.querySelector('[data-vs-hjalp]');
        hd.rammiHjalp = hj ? trim(hj.textContent) : '';
        /* E7: the frame as two small buttons (the kit's radios and sub lines stay, the pictures go) */
        var rv = sk.el.querySelector('.vs-val--rammi');
        if (rv) rv.className += ' vs-val--hnappar';
      }
      /* the old page's URL: prefer (material), variant (its colour), border, font, size and sm.
         Typed names and address are never read from the URL or written to it any more (defect M3). */
      var q = null;
      try { q = new URL(window.location.href).searchParams; } catch (e) { q = null; }
      var fam = (v.FAM_OF[ctx.vara().handle] || {}).fam;
      v.D.family = fam;
      samstillaVoru(ctx);
      if (v.MAT[c.material].fixedSize) c.size = v.MAT[c.material].fixedSize;
      if (v.MAT[c.material].noOval) c.shape = 'rect';
      if (q) {
        /* lysandi slod (review 2026-10-01): "efni" is the Icelandic slug (EFNI_LYKILL_INV), or - for
           the few minutes it was briefly live in English - the raw material code; "prefer" is the old
           link's key. None of the three apply to acrylic any more: its material comes from "litur". */
        var efniSlod = q.get('efni');
        var pref = (efniSlod && EFNI_LYKILL_INV[efniSlod]) || (efniSlod && v.MAT[efniSlod] && efniSlod) || q.get('prefer');
        var pvar = q.get('variant');
        if (pref && v.MAT[pref] && v.inThisProduct(pref)) setjaEfni(v, c, pref);
        else if (!pvar) {
          var liturSlod = q.get('litur'), efniUrLitur = liturSlod && LITUR_EFNI[liturSlod];
          if (efniUrLitur && v.MAT[efniUrLitur] && v.inThisProduct(efniUrLitur)) setjaEfni(v, c, efniUrLitur);
        }
        if (pvar) {
          var ci = -1, V = ctx.vara();
          V.valkostir.forEach(function (o, i) { if (ci < 0 && String(o.nafn).toLowerCase().indexOf('litur') >= 0) ci = i; });
          V.afbrigdi.forEach(function (a) {
            if (String(a.id) !== pvar || ci < 0) return;
            var lv = String(a.n[ci] || '').toLowerCase();
            EFNI.forEach(function (k) { if (v.MAT[k].fam === fam && v.MAT[k].pat.some(function (p) { return lv.indexOf(p) >= 0; })) setjaEfni(v, c, k); });
          });
        }
        /* "letur" (new): the shop's own display name for the font, slugged - never the real font id/name.
           "font" (old link, the real font key) is read only when "letur" is absent. */
        var leturSlod = q.get('letur'), fnt = q.get('font'), HI = window.SMVelSida && window.SMVelSida.handleizeIS;
        if (leturSlod && HI) {
          var lsk2 = ctx.skref('letur');
          if (lsk2 && lsk2.el) Array.prototype.forEach.call(lsk2.el.querySelectorAll('input[type=radio]'), function (r) {
            var nafn = ctx.leturHeiti ? ctx.leturHeiti(r.value) : '';
            if (nafn && HI(nafn) === leturSlod) r.checked = true;
          });
        } else if (fnt && LETUR_ID[fnt]) {
          var lsk = ctx.skref('letur');
          if (lsk && lsk.el) Array.prototype.forEach.call(lsk.el.querySelectorAll('input[type=radio]'), function (r) { r.checked = r.value === LETUR_ID[fnt]; });
        }
        /* staerd (the kit's own generic readable size for this Shopify option) restores c.size through
           the kit already; "size" (old link, the S/M/L internal code) is read only as a fallback */
        var sz = q.get('size');
        if (sz && v.SIZES[sz] && !v.MAT[c.material].fixedSize) { c.size = sz; c.sizeManual = q.get('sm') === '1'; }
        /* border=1|0 of old links becomes the kit's own rammi=med|an before the kit reads it */
        if (q.has('border') && !q.has('rammi')) {
          try { var u = new URL(window.location.href); u.searchParams.set('rammi', q.get('border') === '1' ? 'med' : 'an'); history.replaceState(history.state, '', u.toString()); } catch (e2) {}
        }
        if (q.has('border') || q.has('rammi')) hd.snert = true;
      }
      /* forsida B (15.10.2026, sections/sm-hero-mynd.liquid + assets/sm-hero-mynd.js): the names typed in the box on the
         home page photo. They never travel in the URL (M3 above): the home page keeps them in localStorage
         "sm-forsida-nafn" = {n: names with \n, t: ms} and its link carries only fra=forsida. Read once, only with that
         marker, only into an empty names box and only within 30 minutes; then removed. Same size rule as typing the
         first character into an empty box (Litid, then staekka grows it with the names). */
      if (q && q.get('fra') === 'forsida' && !trim(c.names)) {
        var fs = null;
        try { fs = JSON.parse(window.localStorage.getItem('sm-forsida-nafn') || 'null'); window.localStorage.removeItem('sm-forsida-nafn'); } catch (e3) { fs = null; }
        var fsN = (fs && typeof fs.n === 'string' && +fs.t > 0 && Date.now() - fs.t < 1800000) ? takmarkaNofn(fs.n.replace(/\r/g, '')) : '';
        if (trim(fsN)) {
          if (!c.sizeManual && !v.MAT[c.material].fixedSize && STAERDIR.indexOf(c.size) >= 0) c.size = 'S';
          c.names = fsN;
          staekka(v, c);
        }
        /* 15.10.2026 (forsida B, sm-hero-lifandi.js): the hero's Skraut chip travels the same way ({s: 1}); the material,
           shape (product), frame and font travel in the URL as the readable params this page already reads */
        if (fs && fs.s === 1 && +fs.t > 0 && Date.now() - fs.t < 1800000) {
          var skS = ctx.skref('skraut');
          if (skS && skS.el) Array.prototype.forEach.call(skS.el.querySelectorAll('input[type=radio]'), function (r) { r.checked = r.value === SK_TIGLAR; });
          c.skraut = true;
        }
      }
      if (erTakkar(ctx)) takkaSmida(ctx);
      /* the preview box follows its size (the old page redrew on resize too) */
      var sidast = '';
      var aftur = function () { var r = ctx.teikning.getBoundingClientRect(), k = Math.round(r.width) + 'x' + Math.round(r.height); if (k !== sidast) { sidast = k; ctx.teiknaAftur(); } };
      if ('ResizeObserver' in window) new ResizeObserver(aftur).observe(ctx.teikning);
      else window.addEventListener('resize', aftur);
    },
    /* B1 23.10: the variant a link asked for (the JSON-LD hasVariant URL ?litur=gull&staerd=10-12-cm&heimilisfang=ja, a shared
       readable link or ?variant=<id>) sets the engine's own state, which picks the variant (currentVariant): material from Litur,
       size from Staerd, the address switch from Heimilisfang. Only the options the link named (skyr[j]; null = all, ?variant=).
       A size other than Mid counts as picked (sizeManual), so typing the first name does not drop it to Litid. */
    forval: function (a, skyr, ctx) {
      var hd = ctx.hd;
      if (!hd || !a || !a.n) return;
      var v = hd.vel, c = hd.cfg, V = ctx.vara(), fam = (v.FAM_OF[V.handle] || {}).fam;
      (V.valkostir || []).forEach(function (o, j) {
        if (skyr && !skyr[j]) return;
        var nafn = String(o.nafn || '').toLowerCase(), g = a.n[j], gl = String(g || '').toLowerCase();
        if (!gl) return;
        if (nafn.indexOf('litur') >= 0) {
          var k = null, m = false;
          if (fam === 'metal') {
            ['steel', 'steelg', 'brass'].forEach(function (e) {
              [false, true].forEach(function (mm) { if (!k && liturFyrir(V, e, mm) === g) { k = e; m = mm; } });
            });
            if (k && (k === 'steelg' || k === 'brass')) hd.medferd[k] = m;
          } else {
            EFNI.forEach(function (e) { if (!k && v.MAT[e].fam === fam && v.MAT[e].pat.some(function (p) { return gl.indexOf(p) >= 0; })) k = e; });
          }
          if (k && v.MAT[k] && (k === 'steelg' || v.inThisProduct(k))) setjaEfni(v, c, k);
        } else if (/st\u00e6r\u00f0|staerd/.test(nafn)) {
          if (v.MAT[c.material].fixedSize) return;
          STAERDIR.forEach(function (z) {
            if (v.SIZES[z].pat.some(function (p) { return gl.indexOf(p) >= 0; })) { c.size = z; c.sizeManual = z !== 'M'; }
          });
        } else if (nafn.indexOf('heimilisfang') >= 0) {
          c.includeAddress = gl.indexOf('j\u00e1') === 0;
        }
      });
    },
    hlada: function (ctx) {
      var hd = ctx.hd;
      if (!hd || !document.fonts || !document.fonts.load) return null;
      var f = hd.vel.FONTS;
      return Promise.all(Object.keys(f).map(function (k) { return document.fonts.load(f[k].w + ' 40px ' + f[k].css, 'AaÁðÞæö'); }))['catch'](function () {});
    },
    afbrigdi: function (s, ctx) {
      var hd = ctx.hd;
      lesaStodu(ctx, s);
      var h = hd.vel.matHandle(hd.cfg.material);
      var a = afbrigdiI(ctx, h);
      samstillaVoru(ctx);
      hd.sidastaEfni = hd.cfg.material;
      return a ? { vara: h, id: a.id } : null;
    },
    syna: function (lykill, s, ctx) {
      if (lykill === 'skraut') return !ctx.hd.cfg.includeAddress;
      if (lykill === 'logun') return !ctx.hd.vel.MAT[ctx.hd.cfg.material].noOval;
      /* the kit rebuilds a product's own option steps after a switch to another door product, even with
         syna_valkosti off (core request 1). Material, size, frame and address are this page's own steps,
         so an option step never shows here (a material chosen twice, owner rule O2) */
      if (/^valkostur\d+$/.test(lykill)) return false;
      /* metal without a Rammi option on its product: one real choice (An ramma), so the step is hidden */
      if (lykill === 'rammi' && vantarRamma(ctx)) return false;
      /* one real choice (aluminium has one size): the step is hidden (owner rule), the size shows on the preview */
      if (lykill === 'staerd') return ctx.hd.vel.sizeKeys().length > 1;
    },
    rammi: function (s, ctx) {
      var c = ctx.hd.cfg;
      return rammiGeo(c);
    },
    /* the metal frame copy says the frame costs 1.000 kr; while aluminium, steel and brass have no Rammi option
       (today's data, the frame tile is not offered) the copy is hidden there, so the page never says both */
    hjalp: function (s, ctx) {
      var hd = ctx.hd;
      if (!hd || !hd.rammiHjalp) return null;
      /* E7: the approved copy word for word, only on metal (aluminium, steel, brass) where the frame is offered */
      return { rammi: MALMUR[hd.cfg.material] && !vantarRamma(ctx) ? hd.rammiHjalp : '' };
    },
    teikna: function (ctx, st) {
      var hd = ctx.hd, v = hd.vel, c = hd.cfg;
      samstillaVoru(ctx);
      lesaStodu(ctx, st);
      if (st.rammi) c.border = st.rammi === 'med';
      if (hd.rot.parentNode !== ctx.teikning) { ctx.teikning.innerHTML = ''; ctx.teikning.appendChild(hd.rot); }
      var r = ctx.teikning.getBoundingClientRect(), gg = geo(v, c);
      /* CK 19.10 (QA16 P0): aluminium shows the plate as it is in its photo (AL_SYNILEG), not the wider RECT_GEO.AL box */
      var alGeo = c.size === 'AL' && v.RECT_GEO && v.RECT_GEO.AL;
      if (alGeo && !gg.oval) gg = { top: AL_SYNILEG.top, h: AL_SYNILEG.h, w: AL_SYNILEG.w, left: (1 - AL_SYNILEG.w) / 2, oval: false };
      var a = gg.w / gg.h;
      var bw = Math.max(40, r.width), bh = Math.max(40, r.height);
      var m = mmPlata(c);
      /* 02.10 (eigandi): ONE scale (px per mm) for every size and material of the page, taken from the largest plate
         the family offers (150 x 100 mm), so a 15 x 7,5 cm aluminium plate is as tall as a 12 x 7,5 cm steel plate
         and 1,25 times wider, and a small size looks small. The plate's height follows the photo aspect. */
      var kv = Math.min(bw * 0.9 / 150, bh * 0.86 / 100, 560 / 150);
      /* CK 19.10 (QA16 P2): the plate takes the sign's own proportions (S 120 x 50 mm = 2,40 : 1, the photo 2,55 : 1); only the
         photo stretches to it about the plate's middle, the letters keep their shape, size and place */
      var sy = a / (m.w / m.h);
      if (!(sy > 0.9 && sy < 1.15) || Math.abs(sy - 1) < 0.005) sy = 1;
      var pw = kv * m.w, ph = pw / a * sy, W = pw / gg.w, midja = gg.top + gg.h / 2;
      var pl = hd.plata, sella = pl.firstChild, mynd = sella.firstChild, txt = sella.lastChild;
      pl.style.width = pw + 'px';
      pl.style.height = ph + 'px';
      pl.style.borderRadius = gg.oval ? '50%' : (1.5 / m.w * 100) + '%/' + (1.5 / m.h * 100) + '%';
      sella.style.width = W + 'px';
      sella.style.height = W + 'px';
      sella.style.left = (-gg.left * W) + 'px';
      sella.style.top = (ph / 2 - midja * W) + 'px';
      /* metal draws its band itself, on the frameless photo */
      var br = c.border;
      if (MALMUR[c.material]) c.border = false;
      try { v.renderPlate(); } finally { c.border = br; }
      /* after the engine set the photo cell (its row) */
      if (mynd) {
        var rod = Math.round(-parseFloat(mynd.style.top || 0) / 100) || 0;
        mynd.style.transform = sy === 1 ? '' : 'scaleY(' + r4(sy) + ')';
        mynd.style.transformOrigin = sy === 1 ? '' : '50% ' + r4((rod + midja) / 2 * 100) + '%';
      }
      /* aluminium: the engine lays the letters on RECT_GEO.AL; they shrink to the plate seen (the file keeps its own numbers) */
      if (txt) {
        var alK = alGeo ? AL_SYNILEG.w / alGeo.width : 1;
        txt.style.transform = alK === 1 ? '' : 'scale(' + r4(alK) + ')';
        txt.style.transformOrigin = alK === 1 ? '' : '50% ' + r4((alGeo.top + alGeo.height / 2) * 100) + '%';
      }
      var band = bandSvg(ctx, c, false), gamalt = pl.querySelector('.vs-hurd-band');
      if (gamalt) pl.removeChild(gamalt);
      if (band) pl.insertAdjacentHTML('beforeend', band);
      if (hd.takkarBar) takkaUppfaera(ctx);
    },
    lysing: function (s, ctx) {
      var hd = ctx.hd, v = hd.vel, c = hd.cfg;
      var t = String(c.names || '').split('\n').map(trim).filter(Boolean);
      if (c.includeAddress && trim(c.address)) t.unshift(trim(c.address));
      return ord(ctx, 'lysing', { e: efniSyn(ctx, c.material), d: malTexti(v, c), r: ctx.t(c.border ? 'rammi_med' : 'rammi_an').toLowerCase(), t: t.length ? t.join(', ') : ord(ctx, 'synitexti') });
    },
    /* 14.10: "Daemi" flagan (kitid teiknar hana): medan engin nofn eru slegin inn; heimilisfang telur ekki */
    daemi: function (s, ctx) { var hd = ctx.hd; return hd && hd.vel && !hd.vel.nameCount() ? (ord(ctx, 'daemi_merki') || 'Dæmi, sláðu inn þín nöfn') : false; },
    malband: function (s, ctx) { return { texti: malTexti(ctx.hd.vel, ctx.hd.cfg) + ' cm' }; },
    /* 07.10 (eigandi): smámyndaröðin sýnir aðeins myndir sem passa við valið efni. Akrýl ferhyrnt og sporöskja eru sín eigin
       vara (sama vara og síðan skiptir yfir í), ál líka; stál og messing deila vöru, svo þar er skipt eftir skráarheiti
       (stal / messing) og alt-texta. Mynd sem nefnir hvorugt málminn (almenn) sést undir báðum. Skilar öllu ef ekkert passar. */
    myndir: function (ctx) {
      var c = ctx.hd.cfg, all = ctx.gogn.myndir || [], mat = c.material === 'steelg' ? 'steel' : c.material;
      if (mat !== 'steel' && mat !== 'brass') return all;
      var eigin = mat === 'steel' ? /st[aá]l/i : /messing/i, annar = mat === 'steel' ? /messing/i : /st[aá]l/i;
      var ut = all.filter(function (m) {
        var t = String(m.f || m.src || '').split('?')[0].split('/').pop() + ' ' + String(m.alt || '');
        t = t.toLowerCase();
        return eigin.test(t) || !annar.test(t);
      });
      return ut.length ? ut : all;
    },
    smamynd: function (s, ctx) {
      try { return { html: flisHtml(ctx, afrita({}, ctx.hd.cfg), false) }; } catch (e) { return null; }
    },
    utlit: {
      teikna: function (s2, ctx, o) { return { html: o.tegund === 'rammi' ? '' : flisHtml(ctx, flisCfg(ctx, s2, o), o.lykill === 'staerd', o.lykill !== 'efni' && o.lykill !== 'logun' && o.lykill !== 'skraut') }; },
      lykill: function (s2, ctx, o) { return o.tegund === 'rammi' ? 'hnappur' : flisLykill(flisCfg(ctx, s2, o)); }
    },
    letur: {
      texti: function (s, ctx) { return String(ctx.hd.cfg.names || '').split('\n').map(trim).filter(Boolean)[0] || ''; },
      css: function (id, ctx) {
        var f = ctx.hd.vel.FONTS[LETUR[id]];
        return f ? { fontFamily: f.css, fontWeight: String(f.w), fontStyle: 'normal' } : {};
      },
      flotur: function (s, ctx) {
        var hd = ctx.hd, m = hd.cfg.material, M = hd.vel.MAT[m];
        /* the plate face texture (E5): fills the letter box edge to edge, no swatch disc or white corners */
        return { bak: (hd.sw[m] ? 'url("' + flisEfni(hd, m) + '") 50% 50%/cover no-repeat ' : '') + ({ gold: '#c9a66b', silver: '#b9bcbf', black: '#1d1d1d', white: '#f4f3ef', aluminum: '#2b2b2b', steel: '#b9bcbf', steelg: '#b9bcbf', brass: '#c9a45a' }[m] || '#ddd'), blek: M.text };
      },
      /* the customer's whole first line in each font: one line while it fits at 17 px or more, else two
         lines split between words (22 px down to 14 px, 20 px on phones); the kit's CSS mode keeps one line
         and cuts a full name with "..." (verifier round 1) */
      teikna: function (s2, ctx, o) { return { html: leturFlis(ctx, o.letur || o.gildi, o.texti) }; },
      lykill: function (s2, ctx, o) { var b = leturBox(ctx); return b.w + 'x' + b.h + (b.simi ? 's' : '') + (leturTilbuid(ctx, o.letur || o.gildi) ? 'f' : ''); },
      falid: false
    },
    /* CW 19.10: the paw chip under the names box (sm-vel-sida.js loppaTakkar) */
    loppa: function (ctx, form) { return [].slice.call(form.querySelectorAll('[data-hd-inn="nofn"]')); },
    athuga: function (s, ctx) {
      var hd = ctx.hd, c = hd.cfg, v = [];
      if (TJAKN.test(c.names) || (c.includeAddress && TJAKN.test(c.address))) v.push({ kodi: 'tjakn', reitur: 'nofn', texti: ctx.t('villa_tjakn_loppa') || ctx.t('villa_tjakn'), hnappur: ord(ctx, 'hnappur_tjakn') || 'Taktu t\u00e1knin \u00fat', strax: true });
      if (ofLong(c.names)) v.push({ kodi: 'langt', reitur: 'nofn', texti: ord(ctx, 'villa_lina_long', { n: LINUHAMARK }), hnappur: ord(ctx, 'hnappur_lina_long'), strax: true });
      if (c.includeAddress && !trim(c.address)) v.push({ kodi: 'heimilisfang', reitur: 'nofn', texti: ord(ctx, 'villa_heim'), hnappur: ord(ctx, 'vantar_heim'), strax: false });
      if (!hd.vel.nameCount()) v.push({ kodi: 'nofn', reitur: 'nofn', texti: ord(ctx, 'villa_nofn'), hnappur: ord(ctx, 'vantar_nofn'), strax: false });
      return v;
    },
    /* the old page's visible properties, keys, values and order (sm-hurda-config.js submit handler) */
    eiginleikar: function (s, ctx) {
      var hd = ctx.hd, v = hd.vel, c = hd.cfg;
      lesaStodu(ctx, s);
      if (s.rammi && !vantarRamma(ctx)) c.border = s.rammi === 'med';
      var S = v.SIZES[c.size];
      var p = [
        [ord(ctx, 'eig_efni'), v.MAT[c.material].name],
        [ord(ctx, 'eig_staerd'), ((c.shape === 'oval' && S.oval) ? S.oval : S.dim) + ' cm'],
        [ord(ctx, 'eig_form'), ord(ctx, c.shape === 'oval' ? 'eig_oval' : 'eig_rett')],
        [ctx.eiginleiki('rammi') || ctx.t('rammi'), ctx.t(c.border ? 'rammi_med_is' : 'rammi_an_is') || ctx.t(c.border ? 'rammi_med' : 'rammi_an')],
        [ctx.eiginleiki('skraut') || ord(ctx, 'eig_skraut') || 'Skraut', c.skraut ? SK_TIGLAR : ''],
        [ord(ctx, 'eig_letur'), v.FONTS[c.font].name],
        [ord(ctx, 'eig_nofn'), c.names],
        [ord(ctx, 'eig_heim'), c.includeAddress ? c.address : ''],
        [ctx.eiginleiki('aths') || ord(ctx, 'eig_aths'), s.aths || ''],
        [ord(ctx, c.material === 'brass' ? 'eig_varnar' : 'eig_syru'), medferdNu(ctx) ? ord(ctx, 'eig_ja') : '']
      ];
      return p.filter(function (x) { return !!x[1]; });
    },
    /* the production file: the old page's spec (framSpec measures the preview), the metal band instead of
       the LINA on aluminium, steel and brass */
    framleidsla: function (s, ctx) {
      var hd = ctx.hd, v = hd.vel, F = window.SMFram;
      if (!F || !F.baetaVid || !F.leturFyrir) return null;
      var mv = hd.mvel;
      if (!hd.mrot.parentNode) document.body.appendChild(hd.mrot);
      v.framForhlada();
      var c = hd.cfg, br = c.border;
      return mv.framLetur().then(function (letur) {
        var spec = null;
        if (MALMUR[c.material]) c.border = false;
        try { mv.renderPlate(); spec = mv.framSpec(F); } catch (e) { try { console.warn('[SMFram] hurdaskilti: forskrift (' + (e && e.message) + ')'); } catch (x) {} }
        finally { c.border = br; }
        if (!spec) { var a = v.framAstand(); a.vara = v.framVara(); a.villa = 'forskrift'; return { json: a }; }
        /* 01.10 eigandi: miðjar GRAFA-textann lóðrétt af nákvæmni (mælt á raunverulegu letri skrárinnar
           sjálfrar, sjá SMHurd.framMidjun) áður en málmramminn og letur-athugunin hér fyrir neðan halda áfram
           á sama hátt og áður. */
        return (mv.framMidjun ? mv.framMidjun(F, spec) : Promise.resolve(spec)).then(function (spec2) {
          spec = spec2;
          if (MALMUR[c.material]) {
            spec.gogn.rammi = c.border ? 1 : 0;
            if (c.border) {
              var g = rammiGeo(c), r = window.SMVelSida.rammi(spec.w, spec.h, { gerd: 'malmur', inset: g.inset, band: g.band });
              var ytri = spec.hlutir.pop();
              spec.hlutir = spec.hlutir.concat(r.hlutir, [ytri]);
              spec.lysing = spec.lysing.map(function (x) { return x[0] === 'Rammi' ? r.lysing : x; });
            }
          }
          /* 02.10: letrid kom ekki innan leturBid (8 s). Skrain er SAMT bygg (utlinur koma ur letrum thema, ekki ur
             vefletrinu; adeins uppsetningin var maeld a varaletri) og merkt: gogn.villa = 'letur' i _framleidsla og
             athugasemd i haus skrarinnar. Verkstaedid synir ,Ath.' vid linuna (samstilling.js). Aldrei skra-laus lina. */
          if (!letur) {
            spec.gogn.villa = 'letur';
            try { spec.lysing = (spec.lysing || []).concat([['Athugun', 'vefletrid hladst ekki thegar pantad var, uppsetning maeld a varaletri, skodid skrana']]); } catch (x3) {}
            try { console.warn('[SMFram] hurdaskilti: letrid kom ekki innan 8 s, skrain er bygg samt og merkt'); } catch (x2) {}
          }
          return spec;
        });
      });
    },
    /* heildartimi framleidslunnar (kjarninn: FRAM_TIMI 2400 ms): letur allt ad 8 s, midjun (bua einu sinni) og
       lokabygging, sjalfgefid of stutt a haegu neti (haegt net 200 KB/s: 8 s + 8 s + lokabygging). Hnappurinn synir ,Set i korfu...' a medan. */
    framTimi: 36000,
    forhlada: function (s, ctx) { ctx.hd.vel.framForhlada(); },
    slod: function (s, ctx) {
      var c = ctx.hd.cfg, HI = window.SMVelSida && window.SMVelSida.handleizeIS;
      var leturNafn = s.letur && ctx.leturHeiti ? ctx.leturHeiti(s.letur) : '';
      return {
        rammi: null, border: null, font: null, size: null, sm: null, prefer: null,
        /* "efni": only when the material is NOT already said by "litur" (the real Shopify option) -
           review 2026-10-01: acrylic was writing an English, redundant "efni=silver" next to
           "litur=silfur". A metal/cross-product material gets its own Icelandic slug (EFNI_LYKILL),
           since switching to it is not expressed by any option on this page at all. */
        efni: EFNI_LYKILL[c.material] || null,
        letur: leturNafn && HI ? HI(leturNafn) : null
      };
    }
  };

  if (window.SMVelSida) window.SMVelSida.skra('hurd', A);
  else (window.SMVelSidaBid = window.SMVelSidaBid || []).push(['hurd', A]);
})();
